import "flag-icons/css/flag-icons.min.css";
import { Box } from "@mui/material";

import { radius } from "../tokens/radius";

import type { SxProps, Theme } from "@mui/material/styles";

type FlagProps = {
  countryIso: string;
  square?: boolean;
  sx?: SxProps<Theme>;
};

export function Flag({ countryIso, square = false, sx }: FlagProps) {
  if (!countryIso || countryIso.length !== 2) return null;
  const iso = countryIso.toLowerCase();
  const classes = square ? `fi fis fi-${iso}` : `fi fi-${iso}`;
  return (
    <Box
      component="span"
      className={classes}
      aria-hidden
      data-testid="country-flag"
      sx={[
        (theme) => ({
          borderRadius: radius.sm,
          border: `1px solid ${theme.palette.divider}`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    />
  );
}
